// src/components/ServicePlanCard.js
import React from "react";
import styles from "./ServicePlanCard.module.css";
import * as actions from "../../actions";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { FaRedo } from "react-icons/fa";
import LazyImage from "../LazyImage/LazyImage";

const getProductTitle = (type) => {
  const titles = {
    eSIM: "eSIM",
    Recharge: "Recharge",
  };
  return titles[type] || "Service Plan";
};

const ServicePlanCard = ({
  id,
  product,
  isoCode,
  regionName,
  regionImage,
  isRenew,
  productType,
  price,
  details,
  history,
  auth,
  onBuyClick,
}) => {
  const title = getProductTitle(productType);
  const handleBuyClick = () => {
    if (onBuyClick) {
      onBuyClick(product);
    }
  };

  const handleDetailsClick = () => {
    history.push({ pathname: `/home/productDetail/${id}` });
  };

  return (
    <div className={styles.planCard}>
      <div className={styles.cardHeader}>
        <div className={styles.countryInfo}>
          {regionImage ? (
            <LazyImage
              src={regionImage}
              alt={regionName || "flag"}
              fallback={`${process.env.PUBLIC_URL}/flag.png`}
              className={styles.flagIcon}
              style={{ width: 60, height: 40, borderRadius: 3 }}
              imgStyle={{ width: 60, height: 40, objectFit: "cover", borderRadius: 3 }}
            />
          ) : isoCode ? (
            <span
              className={`fi fi-${isoCode.toLowerCase()} ${styles.flagIcon}`}
              style={{ width: 60, height: 40, borderRadius: 3, display: 'inline-block', backgroundSize: 'cover', backgroundPosition: 'center' }}
            />
          ) : (
            <img
              src={`${process.env.PUBLIC_URL}/flag.png`}
              alt={regionName || "flag"}
              className={styles.flagIcon}
              style={{ width: 60, height: 40, borderRadius: 3 }}
            />
          )}
          {/* {regionName && <span>{regionName}</span>} */}
        </div>
        {/* <div className={styles.regionBadge}>{regionName || "N/A"}</div> */}
      </div>

      <div className={styles.planDetails}>
        {details.map((detail, index) => (
          <p key={index}>{detail}</p>
        ))}
        {/* <div className={styles.productTitle}>
          {title}{" "}
          {isRenew && (
            <span className={styles.renewBadge} title="Renewable">
              <FaRedo className={styles.renewIcon} />
              <span>Renewable</span>
            </span>
          )}
        </div> */}
      </div>

      <div className={styles.price}>{price}</div>

      <div className={styles.buttons}>
        <button
          className={styles.btnSecondary}
          onClick={handleDetailsClick}
        >
          Details
        </button>
        <button className={styles.btnPrimary} onClick={handleBuyClick}>
          Buy Now
        </button>
      </div>
    </div>
  );
};

export default ServicePlanCard;